import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'

const Footer = () => {
  return (
    <footer>
      <Container>
        <Row>
          <Col className='text-center py-3'>Contact 8328371036 to add new birthday wishes</Col>
        </Row>
      </Container>
    </footer>
  )
}

export default Footer
